import { DatePipe } from '@angular/common';
import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, DoCheck, ElementRef, HostListener, Inject, OnChanges, OnInit, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ExcelService } from 'src/app/services/excel.service';
import { PdfService } from 'src/app/services/pdf.service';
import { SendEmailDialogComponent } from '../send-email-dialog/send-email-dialog.component';
import { ModalService } from 'src/app/services/modal.service';
import { zip } from 'rxjs';
import { TypeNotesService } from 'src/app/services/type-notes.service';
import { TiersService } from 'src/app/services/tiers.service';
import { PlatformService } from 'src/app/services/platform.service';
import { TypeNote } from 'src/app/models/type-note.model';
import { Tier } from 'src/app/models/tier.model';
import { Platform } from 'src/app/models/platform';
import { ScreenService } from 'src/app/services/screen.service';

@Component({
  selector: 'app-report-modal',
  templateUrl: './report-modal.component.html',
  styleUrls: ['./report-modal.component.css']
})
export class ReportModalComponent implements OnInit, AfterViewChecked {

  @ViewChild('headerDialog', { static: false }) headerDialog: ElementRef;
  @ViewChild('infoResultados', { static: false }) infoResultados: ElementRef;

  data: any;
  adp_logo = '/assets/img/Logotipo-07.png'
  someDefaultImage = '/assets/img/noimage.png';
  // heightScreen$ = this.screenService.heightScreen$;
  heightScreen = 700;

  tiers: Tier[] = [];

  dataTitleOne: string[] = [];
  dataTableOne: any[] = [];
  dataSliceOne: any[] = [];
  dataTableOneTotals: any[] = [];

  name: string = '';
  dataTableTwo: any[] = [];
  dataSliceTwo: any[] = [];
  title = '';

  typesReport = ['0x1', '1x1', '2x1', '3x1', '5x1', '6x1', '0x2', '1x2', '2x2', '3x2', '4x2', '6x2', '0x3', '1x3', '2x3', '3x3', '4x3', '5x3'];

  @ViewChild('scrollOne', { static: false }) scrollOne: ElementRef;

  searchTerm: string = '';
  filteredDataSliceTwo: any[] = [];

  typeNotes: TypeNote[] = [];

  platforms: Platform[] = [];

  constructor(
    public dialogRef: MatDialogRef<ReportModalComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private excelService: ExcelService,
    private modalService: ModalService,
    private pdfService: PdfService,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    public typeNotesService: TypeNotesService,
    public tiersService: TiersService,
    public platformService: PlatformService,
    private screenService: ScreenService,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2
  ) {
    this.data = this.dialogData;
    this.heightScreen = this.data.heightScreen;
    this.getTypeNotesAndTiers();
  }

  ngOnInit(): void {
    console.log(this.data)
  }

  ngAfterViewChecked(): void {
    const headerDialogWidth = this.headerDialog.nativeElement.offsetWidth;
    const infoResultados = this.infoResultados.nativeElement;
    if (window.innerWidth < 1024) {
      this.renderer.setStyle(infoResultados, 'width', `${headerDialogWidth}px`);
    } else {
      this.renderer.removeStyle(infoResultados, 'width');
    }
  }

  private getTypeNotesAndTiers() {
    zip(
      this.typeNotesService.getAll(),
      this.tiersService.getAll(),
      this.platformService.getAll()
    ).subscribe(
      ([{ data: typeNotes }, { data: tiers }, { plataformas }]: any[]) => {
        this.typeNotes = typeNotes;
        this.tiers = [
          { id: 0, name: 'Sin Tier', backgroundColor: 'bg-gray-500', textColor: 'text-gray-700' },
          ...tiers
        ];

        this.typeNotesService.updateTypeNotes(typeNotes);
        this.tiersService.updateTiers(tiers);
        this.platformService.updatePlatforms(plataformas);

        this.modalView();
        this.applyFilter();
      }
    );
  }

  modalView() {
    const planMediosSortedAndReversed = this.data.params.planmedios.sort().reverse();
    this.data.planmedios = planMediosSortedAndReversed;
    this.dataTableTwo = [];
    this.dataTitleOne = [];
    this.dataTableOne = [];
    this.dataTableOneTotals = [];
    const ylabels = [
      { title: 'Campañas', name: 'Campaign', id: 'idCampaign', arr: this.data.params.campaigns },
      { title: 'Voceros', name: 'Vocero', id: 'idVocero', arr: this.data.params.voceros },
      { title: 'Plan de Medios', name: 'PlanMedio', id: 'idPlanMedio', arr: this.data.params.planmedios },
      { title: 'Plataformas', name: 'Plataforma', id: 'idPlataforma', arr: this.data.params.plataformas },
      { title: 'Tipo de Notas', name: 'note', id: 'tipoNota', arr: this.data.params.tipoNotas },
      { title: 'Tier', name: 'tierName', id: 'tipoTier', arr: this.data.params.tipoTiers.filter(t => !!t) },
    ];
    const xlabels = [
      {
        arrTitle: this.data.params.platforms.map(pl => pl.descripcion),
        arr: this.data.params.plataformas,
        id: 'idPlataforma'
      },
      {
        arrTitle: this.typeNotes.filter(n => this.data.params.tipoNotas.includes(n.id)).map(n => n.name),
        arr: this.data.params.tipoNotas,
        id: 'tipoNota'
      },
      {
        arrTitle: this.tiers.filter(n => this.data.params.tipoTiers.includes(n.id)).map(n => n.name),
        arr: this.tiers.filter(n => this.data.params.tipoTiers.includes(n.id)).map(n => n.id),
        id: 'tipoTier'
      }
    ];

    const x = xlabels[this.data.xlabel - 1];
    const y = ylabels[this.data.ylabel - 1];

    this.title = y.title.toUpperCase();

    if (this.data.type == 1) {

      this.name = y.name;
      let total = 0;
      const count = [];
      this.dataTitleOne = [y.title].concat(x.arrTitle).concat(['Total']);
      y.arr.forEach(cm => {

        const arrResultFiltered = this.data.DPRPs.filter(dt => dt[y.id] == cm);
        const arrSorted = arrResultFiltered.sort((a, b) => a[x.id] - b[x.id]);
        const arrMapped = arrSorted.map((dp, ind) => { 
            dp['showFirst'] = ind == 0
            return dp
          })
        const arrResult = arrMapped;
        if (arrResult.length) {
          this.dataTableOne.push({
            name: arrResult[0][y.name],
            quantity: x.arr.map(pl => arrResult.filter(cp => cp[x.id] == pl).length),
            total: arrResult.length
          })

          x.arr.forEach((pl, ind) => {
            if (count[ind]) {
              count[ind] += arrResult.filter(cp => cp[x.id] == pl).length
            } else {
              count[ind] = arrResult.filter(cp => cp[x.id] == pl).length
            }
          });

          total += arrResult.length
          this.dataTableTwo = this.dataTableTwo.concat(arrResult);
        }
      })
      this.dataTableOneTotals = count.concat([total]);

      const columnsToKeep: number[] = [];

            if (this.dataTableOne.length > 0) {
                // Verificar  columnas tienen algún valor
                for (let i = 0; i < this.dataTableOne[0].quantity.length; i++) {
                    const hasValue = this.dataTableOne.some(item => item.quantity[i] > 0);
                    if (hasValue) {
                        columnsToKeep.push(i);
                    }
                }

                // Filtrar las columnas sin datos
                this.dataTableOne = this.dataTableOne.map(item => ({
                    ...item,
                    quantity: item.quantity.filter((_, idx) => columnsToKeep.includes(idx))
                }));

                // Ajustar encabezados
                this.dataTitleOne = [this.dataTitleOne[0]] 
                    .concat(columnsToKeep.map(i => this.dataTitleOne[i + 1])) 
                    .concat([this.dataTitleOne[this.dataTitleOne.length - 1]]);

                // Ajustar totales
                this.dataTableOneTotals = this.dataTableOneTotals.filter((_, idx) => columnsToKeep.includes(idx) || idx === this.dataTableOneTotals.length - 1);
            }
    }


    if (this.data.type == 2) {

      const z = ylabels[this.data.xlabel + 2];
      this.name = z.name;
      let total = 0;
      this.dataTitleOne = [z.title.toUpperCase(), 'PUBLICACIONES'];
      z.arr.forEach(pl => {
        let arrResult = this.data.DPRPs.filter(dt => dt[z.id] == pl).map((dp, ind) => {
          dp['showFirst'] = ind == 0
          return dp
        })
        if (arrResult.length) {
          this.dataTableTwo = this.dataTableTwo.concat(arrResult);
          this.dataTableOne.push({
            name: arrResult[0][z.name],
            quantity: [],
            total: arrResult.length
          })
          total += arrResult.length;
        }
      })
      this.dataTableOneTotals = [total];
    }

    this.dataSliceOne = this.dataTableOne.slice(0, 10);
    this.dataSliceTwo = this.dataTableTwo.slice(0, 10);
  }

  onModalScrollDownOne() {
    if (this.dataSliceOne.length < this.dataTableOne.length) {
      const lengthArray = this.dataSliceOne.length;
      const lengthArrayTwo = this.dataTableOne.length;
      for (let i = lengthArray; i < lengthArray + 10 && i < lengthArrayTwo; i++) {
        this.dataSliceOne.push(this.dataTableOne[i]);
      }
    }
  }

  onModalScrollDownTwo() {
    if (this.dataSliceTwo.length < this.dataTableTwo.length) {
      const lengthArray = this.dataSliceTwo.length;
      const lengthArrayTwo = this.dataTableTwo.length;
      const itemsToAdd = Math.min(10, lengthArrayTwo - lengthArray);

      for (let i = 0; i < itemsToAdd; i++) {
        const newItem = this.dataTableTwo[lengthArray + i];
        this.dataSliceTwo.push(newItem);
      }
      this.applyFilter();
    }
  }

  applyFilter() {
    if (!this.searchTerm) {
      this.filteredDataSliceTwo = this.dataSliceTwo;
    } else {
      this.filteredDataSliceTwo = this.dataSliceTwo.filter(item =>
        item[this.name].toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    }
  }

  filterReports() {
    this.applyFilter();
  }

  closeModal() {
    if (this.scrollOne) {
      this.scrollOne.nativeElement.scrollTop = 0;
    }
    this.dataSliceOne = this.dataTableOne.slice(0, 10);
    this.dataSliceTwo = this.dataTableTwo.slice(0, 10);
    this.applyFilter();
    this.modalService.closeModal();
  }

  pdf(isPdf) {
    const string = `${this.data.type == 1 ? this.data.ylabel : 0}x${this.data.xlabel}`
    const data = {
      ...this.data.params,
      tipoReporte: this.typesReport.indexOf(string) + 1
    }

    if (isPdf) {
      this.pdfService.pdf(data);
    } else {
      this.dialogRef.close({ sendEmailDialog: true, data });
      // this.dialog.open(SendEmailDialogComponent, {
      //   data: {
      //     data: [],
      //     customer: this.data.customer,
      //     idPlan: 0,
      //     title: 'Envío de reporte',
      //     type: 'reporte',
      //     docs: false,
      //     report: data
      //   },
      //   width: '800px'
      // });
    }
  }

  excel() {
    const name = `Reportex${this.title.toLowerCase().replace(' ', '_')}_${this.datePipe.transform(this.data.params.fechaInicio, 'dd-MM-yyy')}-${this.datePipe.transform(this.data.params.fechaFin, 'dd-MM-yyy')}`;
    const symbol = this.data.params.currency == 'sol' ? 'S/.' : '$';
    let header = [
      { name: 'ID', width: 10 },
      { name: 'CAMPAÑA', width: 35 },
      { name: 'PLAN DE MEDIO', width: 30 },
      { name: 'CONTACTO', width: 35 },
      { name: 'MEDIO', width: 20 },
      { name: 'PROGRAMA', width: 20 },
      { name: 'VOCERO', width: 20 },
      { name: 'PLATAFORMA', width: 20 },
      { name: 'TIPO DE NOTAS', width: 20 },
      { name: 'TIPO TIER', width: 20 },
      { name: 'PUBLICACIÓN', width: 20 },
      { name: `VALORIZACIÓN (${symbol})`, width: 25 },
      { name: `LINK`, width: 50 }
    ];

    if (this.data.ylabel === 2) {
      header = [
        { name: 'ID', width: 10 },
        { name: 'VOCERO', width: 35 },
        { name: 'CAMPAÑA', width: 35 },
        { name: 'PLAN DE MEDIO', width: 30 },
        { name: 'CONTACTO', width: 30 },
        { name: 'MEDIO', width: 20 },
        { name: 'PROGRAMA', width: 20 },
        { name: 'PLATAFORMA', width: 20 },
        { name: 'TIPO DE NOTAS', width: 20 },
        { name: 'TIPO TIER', width: 20 },
        { name: 'PUBLICACIÓN', width: 20 },
        { name: `VALORIZACIÓN (${symbol})`, width: 25 },
        { name: `LINK`, width: 50 }
      ];
    }
    // if (this.data.params.isVal) {
    //   header.push({ name: `VALORIZACIÓN (${symbol})`, width: 25 });
    // }

    if (this.data.params.isDet) {
      const valorizarIndex = header.findIndex(h => h.name.includes('VALORIZACIÓN'));
      header.splice(valorizarIndex + 1, 0, { name: 'ALCANCE', width: 20 });
    }

    const rows = []
    this.data.DPRPs.forEach(item => {
      let rowD = [
        item.idDetallePlanMedio || '',
        item.Campaign || '',
        item.PlanMedio || '',
        item.Contacto || '',
        item.Medio || '',
        item.Programa || '',
        item.Vocero || item.voceros,
        item.Plataforma || '',
        item.note || '',
        item.tierName || '',
        this.datePipe.transform(item.fechaPublicacion, 'dd-MM-yyy'),
        item.valorizar || 0,
        item.url || ''
      ];
      if (this.data.ylabel === 2) {
        rowD = [
          item.idDetallePlanMedio || '',
          item.Vocero || item.voceros,
          item.Campaign || '',
          item.PlanMedio || '',
          item.Contacto || '',
          item.Medio || '',
          item.Programa || '',
          item.Plataforma || '',
          item.note || '',
          item.tierName || '',
          this.datePipe.transform(item.fechaPublicacion, 'dd-MM-yyy'),
          item.valorizar || 0,
          item.url || '',
        ];
      }
      
      // if (this.data.params.isVal) {
      //   rowD.push(item.valorizar || 0);
      // }
      
      if (this.data.params.isDet) {
        const valorizarIndex = rowD.findIndex((_, idx) => idx === 11);
        rowD.splice(valorizarIndex + 1, 0, item.Alcance || 0);
      }
      rows.push(rowD);
    })

    const sendData = {
      name: 'Resultados',
      header: header,
      data: rows,
      total: [],
      autoFilter: true,
      wrap: false,
      style: {
        headerBColor: 'FFFF0000',
        borderColor: 'FFF8F8F8',
        secondCell: 'FFF8F8F8'
      }
    }

    let header2 = null
    if (this.data.params.isDet) {
      header2 = {
        header: ['ALCANCE TOTAL'],
        data: [this.data.alcanceTotal],
        two: false
      }
    }
    if (this.data.params.isVal) {
      header2 = {
        header: ['VALORIZACIÓN TOTAL'],
        data: [symbol + ' ' + this.data.valorizadoTotal],
        two: false
      }
    }
    if (this.data.params.isDet && this.data.params.isVal) {
      header2 = {
        header: ['ALCANCE TOTAL', 'VALORIZACIÓN TOTAL'],
        data: [this.data.alcanceTotal, symbol + ' ' + this.data.valorizadoTotal],
        two: true
      }
    }
    const sheet2 = {
      name: 'Resumen',
      header: this.dataTitleOne.map((t, i) => {
        return {
          name: t,
          width: i == 0 ? 30 : 12
        }
      }),
      data: this.dataTableOne.map(dt => {
        return [dt.name].concat(dt.quantity).concat([dt.total])
      }),
      total: ['TOTAL'].concat(this.dataTableOneTotals),
      autoFilter: false,
      wrap: false,
      header2,
      style: {
        headerBColor: 'FFFF0000',
        footerBColor: "FFE1DA",
        borderColor: 'FFF8F8F8',
        secondCell: 'FFF8F8F8'
      }
    }

    this.excelService.downloadReports(name, [sheet2, sendData])
  }

}
